/* eslint-disable wrap-iife, complexity, max-len, key-spacing */
(function($) {
  'use strict';

  var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  var BREAKPOINT_TABLET = 599;
  var BREAKPOINT_DESKTOP = 1023;
  var SLIDES_TO_SHOW_DESKTOP = 5;
  var SLIDES_TO_SHOW_TABLET = 2;
  var slidesNum;
  var profileCarousels = $('.landing-carousel__items');

  var dotsStatusToggle = function(dot, viewPoint) {
    var dotsStatus = true;

    // Check the viewpoint for desktop
    if (dot <= SLIDES_TO_SHOW_DESKTOP && viewPoint > BREAKPOINT_DESKTOP) {
      dotsStatus = false;
    }

    // Check the viewpoint for tablet
    if (
      dot <= SLIDES_TO_SHOW_TABLET &&
      (viewPoint > BREAKPOINT_TABLET && viewPoint <= BREAKPOINT_DESKTOP)
    ) {
      dotsStatus = false;
    }

    // Check the viewpoint for mobile
    if (dot <= 1 && viewPoint <= BREAKPOINT_TABLET) {
      dotsStatus = false;
    }

    return dotsStatus;
  };

  var initProfileCarousel = function() {
    profileCarousels.each(function() {
      slidesNum = $(this).find('.landing-carousel__item').length;
      var dotStatus = dotsStatusToggle(slidesNum, viewportWidth);

      if (slidesNum >= 1) {
        // eslint-disable-next-line no-unused-vars
        var profileCarousel = $(this).slick({
          dots: dotStatus,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          mobileFirst: true,
          infinite: true,
          responsive: [
            {
              breakpoint: BREAKPOINT_DESKTOP,
              settings: {
                slidesToShow: SLIDES_TO_SHOW_DESKTOP,
                dots: dotStatus,
              },
            },
            {
              breakpoint: BREAKPOINT_TABLET,
              settings: {
                slidesToShow: SLIDES_TO_SHOW_TABLET,
                dots: dotStatus,
              },
            },
          ],
          dotsClass: 'slick-dots slick-dots--colored',
          prevArrow:
            '<button class="btn btn--chevron btn--chevron-left slick-prev"><svg focusable="false" xmlns="http://www.w3.org/2000/svg" width="10" height="16"><path fill="#7D5177" fill-rule="evenodd" d="M1.893 0L0 1.868 6.214 8 0 14.13 1.893 16 10 8z" /></svg>Next</button>',
          nextArrow:
            '<button class="btn btn--chevron btn--chevron slick-next"><svg focusable="false" xmlns="http://www.w3.org/2000/svg" width="10" height="16"><path fill="#7D5177" fill-rule="evenodd" d="M1.893 0L0 1.868 6.214 8 0 14.13 1.893 16 10 8z" /></svg>Previous</button>',
        });
      }
    });
  };

  initProfileCarousel();

  // Recalculate breakpoint on resize
  window.addEventListener('resize', function() {
    viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    profileCarousels.each(function() {
      slidesNum = $(this).find('.landing-carousel__item').length;

      if (slidesNum >= 1) {
        var dotStatus = dotsStatusToggle(slidesNum, viewportWidth);
        $(this).slick(
          'slickSetOption',
          {
            dots: dotStatus,
            responsive: [
              {
                breakpoint: BREAKPOINT_DESKTOP,
                settings: {
                  slidesToShow: SLIDES_TO_SHOW_DESKTOP,
                  dots: dotStatus,
                },
              },
              {
                breakpoint: BREAKPOINT_TABLET,
                settings: {
                  slidesToShow: SLIDES_TO_SHOW_TABLET,
                  dots: dotStatus,
                },
              },
            ],
          },
          true
        );
      }
    });
  });
})(jQuery);
